export default __webpack_public_path__ + "static/hq7-f7102e03d3a3b682ddd1e5137d7cb6ed.jpg";